import { render, staticRenderFns } from "./ImportPathSelect.vue?vue&type=template&id=2d8a04f6&"
import script from "./ImportPathSelect.vue?vue&type=script&lang=ts&"
export * from "./ImportPathSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ImportPathSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports